module.exports = __webpack_public_path__ + "static/media/31n.a45886c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/31n.svg
// module id = 172
// module chunks = 0